import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import type { FullScreenHandle } from 'react-full-screen';

import { silenceFullscreenError } from '../../../utils/silenceFullscreenError';

interface TrackingMapFullScreenProps {
  fullScreenHandler: FullScreenHandle;
}

const TrackingMapFullScreen = ({ fullScreenHandler }: TrackingMapFullScreenProps) => {
  const isFullscreen = fullScreenHandler.active;

  const toggleFullscreen = () => {
    if (isFullscreen) {
      fullScreenHandler.exit().catch(silenceFullscreenError);
    } else {
      fullScreenHandler.enter().catch(silenceFullscreenError);
    }
  };

  return (
    <Button
      onClick={toggleFullscreen}
      variant='outlined'
      size='sm'
      color='default'
      icon={<Icon name={isFullscreen ? 'minimize' : 'maximize'} />}
      aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      className='bg-white'
    />
  );
};

export default TrackingMapFullScreen;
